import { motion } from "framer-motion";
import { MessageCircle, BookOpen } from "lucide-react";
import { Logo } from "./Logo";
import { WA, PHONE } from "./data";
import { ease } from "./motion";

export const Footer = () => (
  <footer className="relative bg-[#070A2C] text-white pt-20 pb-28 md:pb-10 overflow-hidden" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-white/60">Precisa de água quente ou pressão?</p>
          <a href={WA} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-btn" className="group mt-4 inline-flex items-center gap-4 font-display font-black text-3xl md:text-5xl hover:text-[#FFB020] transition-colors">
            {PHONE}
            <MessageCircle className="w-8 h-8 md:w-10 md:h-10 text-[#FF6A13] transition-transform duration-500 group-hover:rotate-[-15deg]" />
          </a>
          <div className="mt-6">
            <a href="https://canva.link/catalogo-rsilva" target="_blank" rel="noopener noreferrer" data-testid="footer-catalog-btn"
              className="group inline-flex items-center gap-3 rounded-full bg-[#FF6A13] text-[#0A0E3F] font-semibold pl-6 pr-2 py-2 hover:bg-[#FFB020] transition-colors duration-300">
              Ver catálogo
              <span className="grid place-items-center w-10 h-10 rounded-full bg-[#0A0E3F] text-white transition-transform duration-500 group-hover:rotate-[-20deg] group-hover:scale-110"><BookOpen className="w-4 h-4" /></span>
            </a>
          </div>
        </div>
        <Logo className="h-24 md:h-28" />
      </div>
      <motion.p
        initial={{ y: "40%", opacity: 0 }} whileInView={{ y: "0%", opacity: 1 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 1.2, ease }}
        className="mt-16 font-display font-black italic text-[24vw] leading-[0.8] tracking-[-0.06em] text-white/[0.06] select-none" aria-hidden="true"
      >RSilva</motion.p>
      <div className="mt-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/60">
        <p>© {new Date().getFullYear()} RSilva - RS Bombas e Aquecedores · Lauro de Freitas - BA</p>
        <p>Aquecimento Solar · Bombas · Piscinas · Gás · Tubos e Conexões</p>
      </div>
    </div>
  </footer>
);

export const WhatsAppFab = () => (
  <motion.a
    href={WA} target="_blank" rel="noreferrer" aria-label="Falar no WhatsApp" data-testid="whatsapp-fab"
    initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 200, damping: 15, delay: 2.2 }}
    whileHover={{ scale: 1.08 }} whileTap={{ scale: 0.94 }}
    className="fixed bottom-5 right-5 z-50 grid place-items-center w-16 h-16 rounded-full bg-[#25D366] text-white shadow-[0_15px_40px_-10px_rgba(37,211,102,0.7)]"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
    <svg viewBox="0 0 32 32" className="relative w-8 h-8 fill-current" aria-hidden="true"><path d="M16 3C9 3 3.3 8.6 3.3 15.6c0 2.4.7 4.7 1.9 6.7L3 29l6.9-2.1c1.9 1 4 1.6 6.1 1.6 7 0 12.7-5.7 12.7-12.7S23 3 16 3zm0 23.2c-1.9 0-3.8-.5-5.4-1.5l-.4-.2-4.1 1.2 1.2-4-.3-.4c-1.1-1.7-1.6-3.6-1.6-5.6C5.4 9.8 10.2 5.1 16 5.1s10.6 4.7 10.6 10.5S21.8 26.2 16 26.2zm5.8-7.9c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.6-1.6-1-.9-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6l-1-2.4c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.2-1.2 2.9s1.2 3.4 1.4 3.6c.2.2 2.4 3.7 5.9 5.2 2.9 1.1 3.5.9 4.1.8.7-.1 2.1-.9 2.4-1.7.3-.8.3-1.5.2-1.7-.1-.2-.3-.3-.6-.4z"/></svg>
  </motion.a>
);
